import apiService from "./BaseApi";
import store from '@/store/index';

const BASE_ENDPOINT_CUSTOM_ANCHORS = '/custom-anchors'

const ContractsTemplatesService = {
    createCustomAnchor: async (anchorName) => apiService.post(BASE_ENDPOINT_CUSTOM_ANCHORS, {
        anchorName,
        currentUserId: store.state.currentUser?.uid
    }),
    deleteCustomAnchor: async (customAnchorId) => apiService.post(`${BASE_ENDPOINT_CUSTOM_ANCHORS}/${customAnchorId}`, {
        currentUserId: store.state.currentUser?.uid
    }),
    getAllCustomsAnchors: async () => apiService.get(BASE_ENDPOINT_CUSTOM_ANCHORS),
    getCustomAnchorById: async (customAnchorId) => apiService.get(`${BASE_ENDPOINT_CUSTOM_ANCHORS}/${customAnchorId}`)
}

export default ContractsTemplatesService;